import { getEnv } from '@ctct/ctct-helpers';

/* 
  Need to import axiosConfig because npm needs to see it
  as a dependency to include it in the lib bundle
*/
// eslint-disable-next-line no-unused-vars

const getBaseUrl = () => `https://app${getEnv()}constantcontact.com/v1/`;

export default getBaseUrl;
